/**
 * @generated SignedSource<<795e269a4fb7646a37b92454898df309>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespContentModuleCreator_browseContentModule$data = {
  readonly description: string | null;
  readonly title: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedStorefrontCreatorLink_browseContentModule">;
  readonly " $fragmentType": "SbRespContentModuleCreator_browseContentModule";
};
export type SbRespContentModuleCreator_browseContentModule$key = {
  readonly " $data"?: SbRespContentModuleCreator_browseContentModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespContentModuleCreator_browseContentModule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespContentModuleCreator_browseContentModule",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedStorefrontCreatorLink_browseContentModule"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "type": "ContentModuleCreator",
  "abstractKey": null
};

(node as any).hash = "c470c3db925ae203b1bf060037ce7c12";

export default node;
